import { waitForObject } from 'global/common/globalUtils';
import RrApiAdapter from 'global/thirdParties/rrApiAdapter';
import RichRelevance from './richRelevance';
import * as productList from './productList';
import * as bundleList from './bundleList';
import catZone from './categoryZone';

const categoryZone = catZone();

export function defaultSearch(zoneIds) {
	if (zoneIds.length <= 0) {
		return Promise.resolve([]);
	}
	return waitForObject(window, 'RR')
		.then(() => {
			const richRelevance = new RichRelevance(window.RR_CONFIG);
			return Promise.resolve(richRelevance.fetch(zoneIds));
		})
		.catch(err => Promise.reject(new Error(err)));
}

export default function initProductAndCategoryZones() {
	const elements = document.querySelectorAll(
		'.rr-categories[data-zone-category-id]',
	);
	const dataZoneCategoryIds = Array.from(elements)?.map(element =>
		element.getAttribute('data-zone-category-id'),
	);
	const tempIds = [
		...new Set([
			window.RR_OD_CONFIG?.fallbackCategoryId
				? window.RR_OD_CONFIG?.fallbackCategoryId
				: undefined,
			...dataZoneCategoryIds,
		]),
	];

	initProductLists(undefined, undefined, tempIds, true);
}

export function initProductLists(
	domNode = document,
	searchFunction = defaultSearch,
	categoryIds = [window.RR_OD_CONFIG?.fallbackCategoryId],
	includeProductZones = false,
) {
	return new Promise((resolve, reject) => {
		if (categoryIds.length === 0) {
			resolve();
		} else {
			const categoryId = categoryIds.shift();

			let productZoneElements = [];

			if (includeProductZones) {
				productZoneElements = productList.findZonesInDomNode(domNode);
			}

			const productZoneElementsToRender =
				productList.prepareZonesToRender(productZoneElements);

			const { productZones, zoneIds, externalVisitor } =
				productList.buildZoneList(productZoneElementsToRender);

			const { categoriesZones, categoryZonePlacementIds } =
				categoryZone.collectCategoryZones(categoryId);

			if (window.RR_OD_CONFIG === undefined) {
				window.RR_OD_CONFIG = {};
			}

			window.RR_OD_CONFIG.fallbackCategoryId = categoryId;

			return searchFunction([...zoneIds, ...categoryZonePlacementIds])
				.then(results => {
					return Promise.all([
						productList.renderZones(productZones, results, externalVisitor),
						categoryZone.renderZones(categoriesZones, results),
					]);
				})
				.catch(error => {
					reject(new Error(error));
				})
				.finally(() => {
					initProductLists(undefined, undefined, categoryIds);
				});
		}
	});
}

export function initProductBundles(domNode = document) {
	const bundleZoneElements = bundleList.findZonesInDomNode(domNode);
	if (bundleZoneElements.length > 0) {
		const { bundleZones, bundleIds } =
			bundleList.buildZoneList(bundleZoneElements);
		const api = new RrApiAdapter(bundleIds);
		api.getData().then(results => {
			bundleList.showMoreButton(results.length);
			return bundleList.renderBundles(bundleZones, results);
		});
	}
}
